import React, {FC} from "react";
import {BrowserRouter as Router, Link, Route, Switch} from "react-router-dom"
import PrivacyPolicy from "./Misc/PrivacyPolicy";
import TermsOfUse from "./Misc/TermsOfUse";
import HeaderUnauthenticated from "./Headers/HeaderUnauthenticated";
import CookieConsent from "react-cookie-consent";
import NftTerms from "./Misc/NftTerms";

interface UnauthenticatedAppProps {
  showHintModal: boolean;
}

const UnauthenticatedApp: FC<UnauthenticatedAppProps> = ({showHintModal}) => {
  return (
    <Router>
      <Switch>
        <Route path="/privacy">
          return <PrivacyPolicy isCognitoUser={false} cognitoUser={{}}/>;
        </Route>
        <Route path="/terms">
          <TermsOfUse isCognitoUser={false} cognitoUser={{}}/>;
        </Route>
        <Route path="/nft_terms" render={() => {
          return <NftTerms isCognitoUser={false} cognitoUser={{}}/>;
        }}/>
        <Route>
          <HeaderUnauthenticated title="Sign In / Sign Up"/>
          {!showHintModal ?
            <CookieConsent enableDeclineButton location="top">
              <p>
                This website stores cookies on your computer. These cookies are used to collect information about how you
                interact with our website and allow us to remember you. We use this information in order to improve and
                customize your browsing experience and for analytics and metrics about our visitors both on this website and
                other media. To find out more about the cookies we use, see our <Link to="/privacy"><span>Privacy Policy</span></Link>.
              </p>
              <p>
                If you decline, your information won’t be tracked when you visit this website. A single cookie will be used
                in
                your browser to remember your preference not to be tracked.
              </p>
            </CookieConsent>
            : null}
        </Route>
      </Switch>
    </Router>
  );
}

export default UnauthenticatedApp;
